import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import useContext from '@/composables/useContext';
import useGiftCard from '@/composables/useGiftCard';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import { LogOutIcon } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'Logout',
  props: {
  showIcon: {
    type: Boolean,
    required: false
  }
},
  setup(__props) {

const props = __props;

const { channel, navigate } = useContext();
const { removeAllGiftCards } = useGiftCard();
const { websiteText } = useWebsiteTexts();
const rootPath = computed(() => {
  return channel.value?.rootPath || '';
});

async function logout() {
  try {
    await removeAllGiftCards();

    if (rootPath.value) {
      await navigate(rootPath.value);
    }
  } catch (ex) {
    console.warn(ex);
    alert(websiteText('global__failed_to_remove_giftcard').value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pointer select-none flex flex-row gap-3 hover:underline",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
  }, [
    (__props.showIcon)
      ? (_openBlock(), _createBlock(_unref(LogOutIcon), {
          key: 0,
          class: "h-4 w-4 text-muted-foreground"
        }))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_unref(websiteText)('header_giftcardlogout').value), 1)
  ]))
}
}

})